import EditIcon from "assets/icons/EditReport.svg";
import PlusIcon from "assets/icons/plus_addTag.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import Button from "components/button/Button";
import { LabelField } from 'components/LabelField';
import Templates from "components/ShareDocuments/Templates";
import React, { useRef, useState } from 'react';
import Select, { components } from "react-select";

const selectControlStyles = {
  backgroundColor: "transparent",
  borderColor: "#E1E1E7",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",

};
const selectStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "200px",
  }),
};

const SendLetterTemplates = ({
  createLetter,
  templatesOptions,
  selectedTemplateOption,
  onSelectTemplateChange,
  selectedTemplate,
  allowCreate = true,
  editTemplate,
  allowEdit = false,
  templateSelectionStyle = {}
}) => {
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };


  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  







  return (
    <div className="send-letter__content__templates__container">
      <div className="send-letter__content__templates__header">
        <div className="send-letter__content__templates__selection"
          style={templateSelectionStyle}
        >
          <LabelField title={"Select a Template"} 
            style={{
              color: "#002E5C",
            }}
          />
            <Select
              menuPosition={'fixed'} 
              classNamePrefix="react-select"
              formatOptionLabel={formatOptionLabel}
              placeholder="Select a Template"
              options={templatesOptions || []}
              styles={selectStyles}
              onChange={(value) => {
                onSelectTemplateChange(value);
              }}
              value={selectedTemplateOption}
              components={{ DropdownIndicator }}
          />
        </div>
        {allowCreate && (
          <div className="send-letter__content__templates__action">
            <Button
              onClick={createLetter}
              variant="secondary-light"
              size="md"
            >
              <img src={PlusIcon} alt="plus" />
              <span>Create</span>
            </Button>
          </div>
        )}
         {allowEdit && (
          <div className="send-letter__content__templates__action">
            <Button
              onClick={editTemplate}
              variant="secondary-light"
              size="md"
            >
               <img 
                src={EditIcon}
                alt="plus" 
                width={18}
              />
              <span>Edit</span>
            </Button>
          </div>
        )}
      </div>
      <hr />
      <Templates
        templateContent={selectedTemplate}
        isLoading={false}
        showTitle={false}
      />

    </div>
  )
}

export default SendLetterTemplates